import LabelValue from './LabelValue'
import { TooltipWrapper, Button } from "@prosolve/common-components-ui"
import { FaInfoCircle, FaDownload } from "react-icons/fa"
import OpenResponseBlock from './OpenResponseBlock'
import Papa from "papaparse"
import moment from 'moment';
import { downloadFile } from "../../../utils"

const roundToPercentage = (rawValue) => (rawValue === null || rawValue === undefined || rawValue === '') ? '-' : `${Math.round(rawValue)}%`;

export default ({
  data = {}
}) => {
  const {
    // Top level data points
    // SF_OF_CODES_ACTIVATED__C: { value: ofCodesActivate } = {},
    SF_OF_CODES_CONSUMED__C: { value: ofCodesConsumed } = {},
    SF_OF_CODES_ALLOCATED__C: { value: ofCodesAllocated } = {},
    SF_STUDENT_RETENTION__C: { value: studentRetention } = {},
    SF_TOTAL_STUDENTS: { value: totalStudents } = {},
    SF_TOTAL_FACILITATORS: { value: totalFacilitators } = {},

    // Student level tag data points
    SURVEY_SUMMER2025_TAGS_COMMUNICATION: { value: communication } = {},
    SURVEY_SUMMER2025_TAGS_COLLABORATION: { value: collaboration } = {},
    SURVEY_SUMMER2025_TAGS_CRITICAL_THINKING: { value: criticalThinking } = {},
    // SURVEY_SUMMER2025_TAGS_CREATIVE_PROBLEM_SOLVING: { value: creativeProblemSolving } = {},
    // SURVEY_SUMMER2025_TAGS_CHARACTER: { value: character } = {},
    SURVEY_SUMMER2025_TAGS_CURIOSITY: { value: curiosity } = {},
    // SURVEY_SUMMER2025_TAGS_ADAPTABILITY: { value: adaptability } = {},
    // SURVEY_SUMMER2025_TAGS_GROWTH_MINDSET: { value: growthMindset } = {},
    // SURVEY_SUMMER2025_TAGS_OWNERSHIP: { value: ownership } = {},
    SURVEY_SUMMER2025_TAGS_SELF_EFFICACY: { value: selfEfficacy } = {},
    SURVEY_SUMMER2025_TAGS_RESILIENCE: { value: resilience } = {},
    // SURVEY_SUMMER2025_TAGS_FUN_ENGAGING: { value: funEngaging } = {},
    // SURVEY_SUMMER2025_TAGS_RELEVANT_MEANINGFUL: { value: relevantMeaningful } = {},
    // SURVEY_SUMMER2025_TAGS_SATISFACTION: { value: satisfaction } = {},
    SURVEY_SUMMER2025_TAGS_SELF_AWARENESS: { value: selfAwareness } = {},
    // SURVEY_SUMMER2025_TAGS_BELONGING_INCLUSION: { value: belongingInclusion } = {},
    SURVEY_SUMMER2025_TAGS_SOCIAL_AWARENESS: { value: socialAwareness } = {},
    SURVEY_SUMMER2025_TAGS_BELONGING: { value: belonging } = {},
    SURVEY_SUMMER2025_TAGS_CREATIVE_THINKING: { value: creativeThinking } = {},
    SURVEY_SUMMER2025_TAGS_FUN_JOY: { value: funJoy } = {},
    SURVEY_SUMMER2025_TAGS_OWNERSHIP_OF_LEARNING: { value: ownershipOfLearning } = {},
    SURVEY_SUMMER2025_TAGS_PERSEVERANCE: { value: perseverance } = {},
    SURVEY_SUMMER2025_TAGS_SELF_MANAGEMENT: { value: selfManagement } = {},
    SURVEY_SUMMER2025_TAGS_SYSTEMS_THINKING: { value: systemsThinking } = {},

    // Facilitator level tag data points

    // SURVEY_FACILITATOR_TAGS_CREATIVE_PROBLEM_SOLVING: { value: fCreativeProblemSolving } = {},
    // SURVEY_FACILITATOR_TAGS_CURIOSITY: { value: fCuriosity } = {},
    // SURVEY_FACILITATOR_TAGS_CHARACTER: { value: fCharacter } = {},
    // SURVEY_FACILITATOR_TAGS_ADAPTABILITY: { value: fAdaptability } = {},
    // SURVEY_FACILITATOR_TAGS_SELF_AWARENESS: { value: fSelfAwareness } = {},
    // SURVEY_FACILITATOR_TAGS_SELF_EFFICACY: { value: fSelfEfficacy } = {},
    // SURVEY_FACILITATOR_TAGS_RESILIENCE: { value: fResilience } = {},
    // SURVEY_FACILITATOR_TAGS_FUN_ENGAGING: { value: fFunEngaging } = {},
    // SURVEY_FACILITATOR_TAGS_OWNERSHIP: { value: fOwnership } = {},
    // SURVEY_FACILITATOR_TAGS_BELONGING_INCLUSION: { value: fBelongingInclusion } = {},
    // SURVEY_FACILITATOR_TAGS_GROWTH_MINDSET: { value: fGrowthMindset } = {},
    // SURVEY_FACILITATOR_TAGS_SOCIAL_AWARENESS: { value: fSocialAwareness } = {},
    // SURVEY_FACILITATOR_TAGS_BELONGING: { value: fBelonging } = {},
    // SURVEY_FACILITATOR_TAGS_FUN_JOY: { value: fFunJoy } = {},
    // SURVEY_FACILITATOR_TAGS_OWNERSHIP_OF_LEARNING: { value: fOwnershipOfLearning } = {},
    // SURVEY_FACILITATOR_TAGS_SYSTEMS_THINKING: { value: fSystemsThinking } = {},

    SURVEY_FACILITATOR_TAGS_PRE_COMMUNICATION: { value: fPreCommunication } = {},
    SURVEY_FACILITATOR_TAGS_PRE_COLLABORATION: { value: fPreCollaboration } = {},
    SURVEY_FACILITATOR_TAGS_PRE_CRITICAL_THINKING: { value: fPreCriticalThinking } = {},
    SURVEY_FACILITATOR_TAGS_PRE_CREATIVE_THINKING: { value: fPreCreativeThinking } = {},
    SURVEY_FACILITATOR_TAGS_PRE_PERSEVERANCE: { value: fPrePerseverance } = {},
    SURVEY_FACILITATOR_TAGS_PRE_SELF_MANAGEMENT: { value: fPreSelfManagement } = {},

    SURVEY_FACILITATOR_TAGS_POST_COMMUNICATION: { value: fPostCommunication } = {},
    SURVEY_FACILITATOR_TAGS_POST_COLLABORATION: { value: fPostCollaboration } = {},
    SURVEY_FACILITATOR_TAGS_POST_CRITICAL_THINKING: { value: fPostCriticalThinking } = {},
    SURVEY_FACILITATOR_TAGS_POST_CREATIVE_THINKING: { value: fPostCreativeThinking } = {},
    SURVEY_FACILITATOR_TAGS_POST_PERSEVERANCE: { value: fPostPerseverance } = {},
    SURVEY_FACILITATOR_TAGS_POST_SELF_MANAGEMENT: { value: fPostSelfManagement } = {},

    // Facilitator ratings data
    SURVEY_FACILITATORS_RATING: { averageRating, averagePositive, percentPlayAgain } = {},
    SURVEY_LICENSED_FACILITATORS_RATING: { value: licensedAveragePositive } = {},

    // Facilitator Open Responses
    SURVEY_FACILITATORS_POST_OPEN_RESPONSES: { /*openResponseOne = [],*/ openResponseTwo = [], openResponseThree = [] } = {},

    // Facilitator Student Testimonials Two
    SURVEY_STUDENT_TESTIMONIALS_TWO: studentTestimonialsTwo = [],
    
  } = data;

  const hasValueIncludingZero = (value) =>   {
    return !(!value && value !== 0);
  }

  const buttonStyle = {
    flexDirection: 'column',
    width: '90px',
    marginLeft: '10px',
    textAlign: 'center'
  }

  const formatPercentValue = (rawValue) => (rawValue === null || rawValue === undefined || rawValue === '') ? '-' : `${Math.round(rawValue)}%`;

  const onDownloadData = () => {
    const row = {
      "Number of Students Reporting": totalStudents || '-',
      "Number of Facilitators Reporting": totalFacilitators || '-',
      "Number of classes implemented / number anticipated": activatedOverAllocated,
      "Student retention rate %": formatPercentValue(studentRetention),
      "% of Facilitators who would want to play QUEST again.": formatPercentValue(percentPlayAgain),
      "Average 10-star rating by Facilitators": averageRating || '-',
      "% who rated it as AWESOME!": formatPercentValue(averagePositive),
      "% of licensed teachers who rated it as AWESOME!": formatPercentValue(licensedAveragePositive),
      "Communication": formatPercentValue(communication),
      "Collaboration": formatPercentValue(collaboration),
      "Social Awareness": formatPercentValue(socialAwareness),
      "Critical Thinking": formatPercentValue(criticalThinking),
      "Creative Thinking": formatPercentValue(creativeThinking),
      "Systems Thinking": formatPercentValue(systemsThinking),
      "Self Awareness": formatPercentValue(selfAwareness),
      "Self-Efficacy": formatPercentValue(selfEfficacy),
      "Self Management": formatPercentValue(selfManagement),
      "Curiosity": formatPercentValue(curiosity),
      "Resilience": formatPercentValue(resilience),
      "Perseverance": formatPercentValue(perseverance),
      "Fun & Joy": formatPercentValue(funJoy),
      "Belonging & Inclusion": formatPercentValue(belonging),
      "Ownership Of Learning": formatPercentValue(ownershipOfLearning),
      "Facilitator: Communication": `Pre : ${roundToPercentage(fPreCommunication)}, Post : ${roundToPercentage(fPostCommunication)} `,
      "Facilitator: Collaboration": `Pre : ${roundToPercentage(fPreCollaboration)}, Post : ${roundToPercentage(fPostCollaboration)} `,
      "Facilitator: Critical Thinking": `Pre : ${roundToPercentage(fPreCriticalThinking)}, Post : ${roundToPercentage(fPostCriticalThinking)} `,
      "Facilitator: Creative Thinking": `Pre : ${roundToPercentage(fPreCreativeThinking)}, Post : ${roundToPercentage(fPostCreativeThinking)} `,
      "Facilitator: Perseverance": `Pre : ${roundToPercentage(fPrePerseverance)}, Post : ${roundToPercentage(fPostPerseverance)} `,
      "Facilitator: Self Management": `Pre : ${roundToPercentage(fPreSelfManagement)}, Post : ${roundToPercentage(fPostSelfManagement)} `,
    };

    // data.push(row);

    const data = Object.entries(row).map(([label, value]) => ({
      Label: label,
      Value: value,
    }));

    const currentDateTime = moment().format('MM/DD/YY-HH:mm:ss')
    const filename = `Data Snacks Full Dashboard - ${currentDateTime}.csv`

    downloadFile({ 
      filename: filename,
      fileDataParts: [Papa.unparse(data)], 
      type: 'text/csv;charset=utf-8'
    })
  }

  const activatedOverAllocated = (hasValueIncludingZero(ofCodesConsumed) && hasValueIncludingZero(ofCodesAllocated)) ? `${ofCodesConsumed} / ${ofCodesAllocated}` : '-'

  const studentRetentionText = `We track student headcount at the start of each episode and can report total participation, such as "120 kids played QUEST." Retention is calculated by dividing the final day's attendance by the maximum attendance, allowing us to say, for example, "115 out of 120 kids remained through to the last day," which is a 95.8% retention rate.

For assessment reporting, we calculate the average number of students per team (e.g., 30 kids in 6 teams equals 5 kids per team) and multiply that by the number of positive team responses. For example, if 4 teams gave a "double thumbs up," we estimate 4 × 5 = 20 students responded positively, which can then be aggregated for each question or category into a percentage.
`

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '15px'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        paddingBottom: '5px',
        borderBottom: '1px solid #565656',
      }}>
        <div style={{
          color: '#565656',
          fontSize: '24px',
          fontWeight: 'bold',
          
          flex: 1,
        }}>
          {'Core Data'}
        </div>
                  <Button
            style={buttonStyle}
            onClick={() => {
              onDownloadData()
            }}
          >
            <FaDownload style={{ marginBottom: '2px', color: '#0280c6', fontSize: '14px' }} />
            <span style={{ color: '#565656', fontSize: '14px' }}>{'Download'}</span>
          </Button>
      </div>

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        padding: '5px',
        gap: '15px',
      }}>
        <LabelValue
          label='Number of Students Reporting'
          value={totalStudents || '-'}
        />
        <LabelValue
          label='Number of Facilitators Reporting'
          value={totalFacilitators || '-'}
        />
        <LabelValue
          label='Number of classes implemented / number anticipated'
          value={activatedOverAllocated}
        />
        <div style={{ display: 'flex', gap: '15px' }}>
          <LabelValue
            label='Student retention rate %'
            value={studentRetention}
            isPercent={true}
          />
          <TooltipWrapper text={<div style={{ width: '800px'}}>{studentRetentionText}</div>}>
            <FaInfoCircle style={{ fontSize: '14px', color: '#0280c6' }} />
          </TooltipWrapper>
        </div>
        {/* <div style={{
          color: '#565656',
          fontSize: '22px',
          fontWeight: 'bold',
          marginTop: '20px'
        }}>
          {'Facilitators Rating'}
        </div> */}
        <LabelValue
          label='% of Facilitators who would want to play QUEST again. '
          value={percentPlayAgain}
          isPercent={true}
        />
        <LabelValue
          label='Average 10-star rating by Facilitators'
          value={averageRating || '-'}
        />
        <LabelValue
          label='% who rated it as AWESOME!'
          value={averagePositive}
          isPercent={true}
        />
        <LabelValue
          label='% of licensed teachers who rated it as AWESOME!'
          value={licensedAveragePositive}
          isPercent={true}
        />
      </div>

      <div style={{
        color: '#565656',
        fontSize: '24px',
        fontWeight: 'bold',
        borderBottom: '1px solid #565656'
      }}>
        {'Student Level Data'}
      </div>

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        padding: '5px',
        gap: '15px',
      }}>

        <div style={{
          color: '#565656',
          fontSize: '20px',
          fontWeight: 'bold',
        }}>
          {'Human who Connect'}
        </div>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          padding: '5px 20px',
          gap: '15px',
        }}>
          <LabelValue
            label='Communication'
            value={communication}
            isPercent={true}
          />
          <LabelValue
            label='Collaboration'
            value={collaboration}
            isPercent={true}
          />
          <LabelValue
            label='Social Awareness'
            value={socialAwareness}
            isPercent={true}
          />
          {/* 
          <LabelValue
            label='Creative Problem Solving'
            value={creativeProblemSolving}
            isPercent={true}
          />
          <LabelValue
            label='Character'
            value={character}
            isPercent={true}
          />
          <LabelValue
            label='Adaptability'
            value={adaptability}
            isPercent={true}
          />   */}
        </div>

        <div style={{
          color: '#565656',
          fontSize: '20px',
          fontWeight: 'bold',
        }}>
          {'Humans Who Solve'}
        </div>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          padding: '5px 20px',
          gap: '15px',
        }}>
          <LabelValue
            label='Critical Thinking'
            value={criticalThinking}
            isPercent={true}
          />
          <LabelValue
            label='Creative Thinking'
            value={creativeThinking}
            isPercent={true}
          />
          <LabelValue
            label='Systems Thinking'
            value={systemsThinking}
            isPercent={true}
          /> 
          {/* <LabelValue
            label='Growth Mindset'
            value={growthMindset}
            isPercent={true}
          />
          <LabelValue
            label='Ownership'
            value={ownership}
            isPercent={true}
          />
          */}
        </div>

        <div style={{
          color: '#565656',
          fontSize: '20px',
          fontWeight: 'bold',
        }}>
          {'Humans Who Adapt'}
        </div>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          padding: '5px 20px',
          gap: '15px',
        }}>
          <LabelValue
            label='Self Awareness'
            value={selfAwareness}
            isPercent={true}
          />
          <LabelValue
            label='Self-Efficacy'
            value={selfEfficacy}
            isPercent={true}
          />
          <LabelValue
            label='Self Management'
            value={selfManagement}
            isPercent={true}
          />
          <LabelValue
            label='Curiosity'
            value={curiosity}
            isPercent={true}
          />
          <LabelValue
            label='Resilience'
            value={resilience}
            isPercent={true}
          /> 
          <LabelValue
            label='Perseverance'
            value={perseverance}
            isPercent={true}
          />
          {/* <LabelValue
            label='Fun & Engaging'
            value={funEngaging}
            isPercent={true}
          />
          <LabelValue
            label='Relevant/Meaningful'
            value={relevantMeaningful}
            isPercent={true}
          />
          <LabelValue
            label='Satisfaction'
            value={satisfaction}
            isPercent={true}
          />
          <LabelValue
            label='Belonging/Inclusion'
            value={belongingInclusion}
            isPercent={true}
          />
          */}
        </div>

        <div style={{
          color: '#565656',
          fontSize: '20px',
          fontWeight: 'bold',
        }}>
          {'Engagement'}
        </div>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          padding: '5px 20px',
          gap: '15px',
        }}>
          <LabelValue
            label='Fun & Joy'
            value={funJoy}
            isPercent={true}
          />
          <LabelValue
            label='Belonging & Inclusion'
            value={belonging}
            isPercent={true}
          />

          <LabelValue
            label='Ownership Of Learning'
            value={ownershipOfLearning}
            isPercent={true}
          />
        </div>

      </div>

      <div style={{
        color: '#565656',
        fontSize: '24px',
        fontWeight: 'bold',
        borderBottom: '1px solid #565656'
      }}>
        {'Facilitator Data'}
      </div>

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        padding: '5px 20px',
        gap: '15px',
      }}>

        <LabelValue
          label='Communication'
          value={`Pre : ${roundToPercentage(fPreCommunication)}, Post : ${roundToPercentage(fPostCommunication)} `}
        />
        <LabelValue
          label='Collaboration'
          value={`Pre : ${roundToPercentage(fPreCollaboration)}, Post : ${roundToPercentage(fPostCollaboration)} `}
        />
        <LabelValue
          label='Critical Thinking'
          value={`Pre : ${roundToPercentage(fPreCriticalThinking)}, Post : ${roundToPercentage(fPostCriticalThinking)} `}
        />
        <LabelValue
          label='Creative Thinking'
          value={`Pre : ${roundToPercentage(fPreCreativeThinking)}, Post : ${roundToPercentage(fPostCreativeThinking)} `}
        />
        <LabelValue
          label='Perseverance'
          value={`Pre : ${roundToPercentage(fPrePerseverance)}, Post : ${roundToPercentage(fPostPerseverance)} `}
        />
        <LabelValue
          label='Self Management'
          value={`Pre : ${roundToPercentage(fPreSelfManagement)}, Post : ${roundToPercentage(fPostSelfManagement)} `}
        />

        {/* <LabelValue
          label='Pre Communication'
          value={fPreCommunication}
          isPercent={true}
        />
        <LabelValue
          label='Pre Collaboration'
          value={fPreCollaboration}
          isPercent={true}
        />
        <LabelValue
          label='Pre Critical Thinking'
          value={fPreCriticalThinking}
          isPercent={true}
        />
        <LabelValue
          label='Pre Creative Thinking'
          value={fPreCreativeThinking}
          isPercent={true}
        />
        <LabelValue
          label='Pre Perseverance'
          value={fPrePerseverance}
          isPercent={true}
        />
        <LabelValue
          label='Pre Self Management'
          value={fPreSelfManagement}
          isPercent={true}
        />

        <LabelValue
          label='Post Communication'
          value={fPostCommunication}
          isPercent={true}
        />
        <LabelValue
          label='Post Collaboration'
          value={fPostCollaboration}
          isPercent={true}
        />
        <LabelValue
          label='Post Critical Thinking'
          value={fPostCriticalThinking}
          isPercent={true}
        />
        <LabelValue
          label='Post Creative Thinking'
          value={fPostCreativeThinking}
          isPercent={true}
        />
        <LabelValue
          label='Post Perseverance'
          value={fPostPerseverance}
          isPercent={true}
        />
        <LabelValue
          label='Post Self Management'
          value={fPostSelfManagement}
          isPercent={true}
        /> */}

        {/* <LabelValue
          label='Creative Problem Solving'
          value={fCreativeProblemSolving}
          isPercent={true}
        /> */}
        {/* <LabelValue
          label='Curiosity'
          value={fCuriosity}
          isPercent={true}
        /> */}
        {/* <LabelValue
          label='Character'
          value={fCharacter}
          isPercent={true}
        /> */}
        {/* <LabelValue
          label='Adaptability'
          value={fAdaptability}
          isPercent={true}
        /> */}
        {/* <LabelValue
          label='Self-Awareness'
          value={fSelfAwareness}
          isPercent={true}
        /> */}
        {/* <LabelValue
          label='Self-Efficacy'
          value={fSelfEfficacy}
          isPercent={true}
        /> */}
        {/* <LabelValue
          label='Resilience'
          value={fResilience}
          isPercent={true}
        /> */}
        {/* <LabelValue
          label='Engagement/Fun'
          value={fFunEngaging}
          isPercent={true}
        /> */}
        {/* <LabelValue
          label='Ownership of Learning'
          value={fOwnership}
          isPercent={true}
        /> */}
        {/* <LabelValue
          label='Belonging/Inclusive '
          value={fBelongingInclusion}
          isPercent={true}
        /> */}
        {/* <LabelValue
          label='Growth Mindset'
          value={fGrowthMindset}
          isPercent={true}
        /> */}
        {/* <LabelValue
          label='Social Awareness'
          value={fSocialAwareness}
          isPercent={true}
        /> */}

        <div style={{
          color: '#565656',
          fontSize: '22px',
          fontWeight: 'bold',
          marginTop: '20px'
        }}>
          {'Facilitators Open Responses'}
        </div>

        {/*
        <OpenResponseBlock
          header='Question: “What did you hear students say about QUEST? Share stories or quotes!”'
          data={openResponseOne}
        />
        */}

        <OpenResponseBlock
          header='Question: “What did you hear the kids say about QUEST today? Share quotes and funny moments!”'
          data={studentTestimonialsTwo}
        />

        <OpenResponseBlock
          header='Question: “Share with us what you love about QUEST and why you believe it is an awesome experience!”'
          data={openResponseTwo}
        />

        <OpenResponseBlock
          header='Question: “Do you have any ideas on ways we could improve or make the QUEST experience better?”'
          data={openResponseThree}
        />

      </div>

    </div>
  )
}